// Body of the expired-login-token view: the toppers account-shell layout (side
// nav + content title). Two states, selected server-side by email_sent: the
// sent confirmation paragraph, or the reCAPTCHA-gated verification form (the
// ReCaptchaV3 widget is not reactivated-serializable, so it renders as the
// standalone ReactivatedReCaptchaField and its errors flatten into props.errors,
// matching the {% for field in form %} render). All copy arrives pre-localized
// as props (server-side gettext). Kept as a site body rather than the shared
// libs ExpiredTokenBody: toppers' AccountShell renders its SideNav
// selfManaged (the global `.accordion` handler is retired here).
import { Immutable } from "immer";
import React from "react";
import { FormErrorList } from "tsi-common-react/src/forms/FormErrorList/index";
import {
    ReactivatedReCaptchaField,
    useReCaptchaSubmit,
} from "tsi-common-react/src/forms/ReactivatedReCaptcha/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountShell } from "../AccountShell";

type IProps = Immutable<templates.ExpiredTokenDocumentTemplate>;

export const ExpiredTokenBody = (props: IProps): React.JSX.Element => {
    // Hooks must run unconditionally, so resolve the submit handler at the top
    // of the component body (it is only attached in the form state).
    const onSubmit = useReCaptchaSubmit(props.recaptcha_action);
    return (
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
            phoneDisplay={props.phone_display}
            phoneHref={props.phone_href}
        >
            {props.email_sent ? (
                <p>{props.sent_message}</p>
            ) : (
                <>
                    <p>{props.intro_message}</p>
                    <form
                        className={FORM_CLASS_NAME}
                        method="post"
                        action={props.action_url}
                        onSubmit={onSubmit}
                    >
                        <CSRFToken />
                        {props.errors.length > 0 && (
                            <div className={FORM_FIELD_CLASS_NAME}>
                                <FormErrorList errors={props.errors} />
                            </div>
                        )}
                        <input
                            type="hidden"
                            name="user"
                            value={props.user_value}
                        />
                        <input
                            type="hidden"
                            name="next"
                            value={props.next_value}
                        />
                        <ReactivatedReCaptchaField />
                        <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                            <input
                                type="submit"
                                className="button button--full-width"
                                value={props.submit_text}
                            />
                        </div>
                    </form>
                </>
            )}
        </AccountShell>
    );
};
